import { environment as configDev } from './environment';
import { environment as configProd } from './environment.prod';
import { environment as configStaging } from './environment.staging';

function getConfig() {
  if (typeof process !== 'undefined' && process.env) {
    if (process.env.RUN_ENV === 'production') {
      return configProd;
    }
    if (process.env.RUN_ENV === 'staging') {
      return configStaging;
    }
    return configDev;
  }
  if (typeof window !== 'undefined' && window['__APP_CONFIG__']) {
    return window['__APP_CONFIG__'];
  }
  // Fallback to development config for SSR or when configuration cannot be determined
  return configDev;
}

export const config = getConfig();
